import { Button } from "@material-ui/core";
import { Link } from "react-router-dom";
import { FONTS } from "../../constants";

import styles from "../loading.module.css";
import { createStyles, makeStyles, Theme } from "@material-ui/core";

type emptyMessageType = {
	image: string;
	message1: string;
	message2: string;
	button?: boolean;
	marginTop?: string;
	imgSize?: string;
};

const useStyles = makeStyles((theme: Theme) => {
	return createStyles({
		rotate: {},
	});
});

export function EmptyMessage({
	image,
	message1,
	message2,
	button = true,
	marginTop = "150px",
	imgSize = "250px",
}: emptyMessageType) {
	const classes = useStyles();
	return (
		<div
			style={{
				width: "100%",
				justifyContent: "center",
				marginTop: marginTop,
				marginLeft: "-00px",
			}}
		>
			<div
				style={{
					textAlign: "center",
					marginBottom: "30px",
				}}
			>
				<img
					className={styles.rotate2}
					style={{
						width: imgSize,
						alignContent: "center",
						opacity: 0.9,
						marginLeft: "-10px",
					}}
					src={image}
				></img>
			</div>
			<div
				style={{
					fontFamily: FONTS,
					color: "rgba(0,0,0,0.7)",
					fontSize: "19px",
					textAlign: "center",
				}}
			>
				{message1}
			</div>
			<div
				style={{
					fontFamily: FONTS,
					color: "rgba(0,0,0,0.3)",
					fontSize: "13px",
					textAlign: "center",
				}}
			>
				{message2}
			</div>
			<div
				style={{
					textAlign: "center",
					marginTop: "30px",
				}}
			>
				{button ? (
					<Link
						to={"/dashboard/training"}
						style={{ textDecoration: "none" }}
					>
						<Button
							variant="outlined"
							style={{
								fontFamily: FONTS,
								fontWeight: "bold",
								width: "160px",
								height: "40px",
								color: "rgba(0,0,0,0.8)",
							}}
						>
							Go There
						</Button>
					</Link>
				) : (
					<div></div>
				)}
			</div>
		</div>
	);
}
